import { getJson } from '~shared/utils/http';
import {
    MADE_FOR_YOU_WIDGET_TYPE_HOME,
    MADE_FOR_YOU_WIDGET_TYPE_MAIN,
    MADE_FOR_YOU_FOR_TODAY_TYPE,
    MADE_FOR_YOU_WON_TYPE,
    MADE_FOR_YOU_BACKED_TYPE,
    MADE_FOR_YOU_TYPES,
} from '~scenes/madeforyou/constants';

import {
    mfyLoading,
    betcardsLoadSuccess,
    betcardsHasErrored,
    clearBetcards,
    setTabList,
} from '~scenes/madeforyou/app/actions/mfyActions';

import { buildSpectateUrl } from '~spa/Utils/Spectate';
import { initialiseCommonStore } from '~shared/components/react/CommonDataStore/actions';

/**
 * Fetch betcards from backend
 * @param {string} activeTab which determines the type of the request
 * @param {Boolean} isWidget string is using homepage widget
 * @param {Boolean} isUserLoggedIn wheter user is logged in
 * @param {Object} lazyLoadContext lazyload called when loading complete
 * @param {Function} dispatch dispatch method for redux updates
 * @param {function} callback callback when loading complete
 * @returns {array} array of betcard objects
 */
 export const getBetCards = (activeTab, isWidget, isUserLoggedIn, lazyLoadContext, dispatch) => {
    const isForTodayRequest = activeTab === MADE_FOR_YOU_FOR_TODAY_TYPE;
    const shouldMakeRequest = isForTodayRequest || isUserLoggedIn;
    const { lazyLoadHasLoaded, lazyLoadIsEmpty } = lazyLoadContext;

    // resetLoadingStatus will be called regardless of whether the request is made or not.
    const resetLoadingStatus = () => {
        dispatch(mfyLoading(false, activeTab));
        lazyLoadHasLoaded();
    };

    if (!shouldMakeRequest) {
        resetLoadingStatus();

        return;
    }

    const widgetType = isWidget ? MADE_FOR_YOU_WIDGET_TYPE_HOME : MADE_FOR_YOU_WIDGET_TYPE_MAIN;

    dispatch(mfyLoading(true, activeTab));
    getJson(buildSpectateUrl(`/madeforyou/getWidgetBetCards/${activeTab}/${widgetType}`))
    .then((response) => {
        if(response.ok) {
            return response.json();
        }
        throw new Error(response.statusText);
    })
    .then((data) => {
        if (data.is_disabled) {
            lazyLoadIsEmpty();
            dispatch(clearBetcards());

            return;
        }

        if(isWidget && !isForTodayRequest) {
            const {
                isBackedHidden = false,
                isWonHidden = false,
            } = data;

            const tabList = MADE_FOR_YOU_TYPES
            .filter(tab => {
                switch (tab) {
                    case MADE_FOR_YOU_WON_TYPE:
                        return !isWonHidden;
                    case MADE_FOR_YOU_BACKED_TYPE:
                        return !isBackedHidden;
                    default:
                        return true;
                }
            });

            dispatch(setTabList(tabList));
        }

        dispatch(initialiseCommonStore(data.events));
        dispatch(betcardsLoadSuccess(data, activeTab));
    })
    .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
        dispatch(betcardsHasErrored(true, activeTab));
    })
    .finally(resetLoadingStatus);
};
